<template>
  <div class="statistics-table__row  _footer">
    <div class="statistics-table__cell  _partner  _footer">
      {{ $tStatistic('total:') }}
    </div>

    <div v-for="(key, index) in keys"
         :key="key"
         :class="{_hover: hoverCell === index}"
         class="statistics-table__cell  _footer">
      {{ total[key] }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StatisticsPageTableFooter',
    props: {
      total: Object,
      mainCells: Object,
      hoverCell: Number,
    },
    computed: {
      keys() {
        return Object.keys(this.mainCells)
      }
    }
  }
</script>

<style lang="less">

</style>
